import React from 'react'
import _ from 'lodash'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import PropTypes from 'prop-types'

import BannerItemModal from './BannerItemModal'
import withReduxModal from '../../../modules/redux-modal/redux/withReduxModal'
import { updateBanner, createBanner } from '../../../actions/banners'
import { CREATE_BANNER_ITEM } from '../../../constants/actions'

class BannerItemModalWithRedux extends React.Component {
  static propTypes = {
    banner: PropTypes.object,
    town: PropTypes.object.isRequired,
  }

  handleModalClose = result => {
    this.props.modalActions.hideModal()

    if (!result) return

    const { action, values } = result

    if (!_.isEmpty(values)) {
      if (action === CREATE_BANNER_ITEM) {
        this.props.actions.createBanner(values)
      } else {
        this.props.actions.updateBanner(values)
      }
    }
  }

  render() {
    if (_.isEmpty(this.props.banner)) {
      return null
    }

    return (
      <BannerItemModal
        params={{ banner: { ...this.props.banner, town: this.props.town._id } }}
        onRequestClose={this.handleModalClose}
      />
    )
  }
}

export default compose(
  withReduxModal,
  connect(
    ({ banners, town }, { modal: { openParams: params } }) => {
      return {
        banner: _.find(banners, { _id: _.get(params, 'bannerID') }),
        town,
      }
    },
    dispatch => ({
      actions: bindActionCreators(
        { updateBanner: updateBanner, createBanner: createBanner },
        dispatch,
      ),
    }),
  ),
)(BannerItemModalWithRedux)



// WEBPACK FOOTER //
// ./src/components/templates/banner-item/BannerItemModalWithRedux.js